// extracted by mini-css-extract-plugin
export var buttonInterest = "productDetail-module--button-interest--10dwM";
export var qrContainer = "productDetail-module--qr-container--2Yn9t";
export var specification = "productDetail-module--specification--36m6_";
export var specificationLabel = "productDetail-module--specification-label--1qLA5";
export var floorplan = "productDetail-module--floorplan--lziY-";
export var siteplan = "productDetail-module--siteplan--MjQtB";
export var masterplan = "productDetail-module--masterplan--3hm4I";
export var buttonLink = "productDetail-module--button-link--whSEJ";
export var carouselIcon = "productDetail-module--carousel-icon--3O5Dr";